exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custo {\n  background-color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/phone/config/providers/components/list-providers/list-providers.component.scss
// module id = ../../../../../src/app/phone/config/providers/components/list-providers/list-providers.component.scss
// module chunks = main